import { sendClickCTAGenerateAIQuestionsInsightsEvent } from '../index';
import { EventAdapter } from './EventAdapter';

export class InsightsGenerateQuestionsCTAEventAdapter extends EventAdapter {
  protected intercomEventKey = null;
  protected amplitudeEventFunction = sendClickCTAGenerateAIQuestionsInsightsEvent;

  constructor() {
    super();
    this.eventData = {};
  }
}